import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/button';

export function NotFound() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-2xl font-bold">Not found</h1>
      <p className="text-muted-foreground">The page you were looking for is not available.</p>
      <Link to="/app" className={buttonVariants({ variant: 'outline' })}>
        Back to dashboard
      </Link>
    </div>
  );
}
